import { useState } from "react";
import clsx from "clsx";

import Header from "components/Header";
import ManageFundingRequest from "features/main/HaulPay/Shared/EditFundingRequest/Manage";
import MainLayout from "layouts/Main";
import { ICompany } from "models/HaulPay";
import { BrokerProvider } from "context/BrokerContext";

export default function CarrierFundingRequest() {
  const [isShowSearch, setIsShowSearch] = useState(false);
  const [companyValue, setCompanyValue] = useState<ICompany>();

  return (
    <BrokerProvider>
      <MainLayout
        desktopTitle="Manage Pay"
        customHeader={<Header label="Funding Request" />}
        className="h-full mobile:!overflow-y-hidden"
        hideNavigation>
        <div className={clsx("mobile:pb-24 mobile:h-full", isShowSearch && "hidden")}>
          <ManageFundingRequest
            setIsShowSearch={setIsShowSearch}
            companyValue={companyValue}
            setCompanyValue={setCompanyValue}
          />
        </div>
      </MainLayout>
    </BrokerProvider>
  );
}
